import React from "react";
import PropTypes from "prop-types";
import { browserHistory } from "react-router";
import { MenuItem, IconButton } from "@mui/material";
import { Menu, ArrowBack } from "@mui/icons-material";
import find from "lodash/find";
import get from "lodash/get";
import { FormattedMessage } from "react-intl";
import RoundedButton from "components/ButtonRounded";
import PointsLabel from "components/PointsLabel";
// import RSSelectField from 'components/RSSelectField';
import AppBarStyled from "./AppBarStyled";
import { showBackButton, getPathMessage /* ,  languages*/ } from "./helpers";
import messages from "./messages";

const styles = {
  titleStyle: {
    cursor: "pointer",
    fontSize: 20,
    color: "#000000",
    textAlign: "center",
  },
  popover: {
    marginTop: 13,
    width: "100%",
    borderRadius: 0,
  },
  menuItemNameSelected: {
    color: "black",
  },
  menuItemValueSelected: {
    color: "#bc236e",
  },
  custom: {
    flex: 1,
  },
};
let lastScrollY = 0;
class HeaderMobile extends React.PureComponent {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
    this.renderPointsPerCategory = this.renderPointsPerCategory.bind(this);
    this.handleScroll = this.handleScroll.bind(this);

    this.state = {
      pointsPopoverVisible: false,
      showShadow: false,
    };
    this.withShadow = false;
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll, true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll(event) {
    lastScrollY = event.target.scrollTop;
    if (lastScrollY > 70 && !this.withShadow) {
      this.setState({
        showShadow: true,
      });
      this.withShadow = true;
    } else if (this.withShadow && lastScrollY < 70) {
      this.setState({
        showShadow: false,
      });
      this.withShadow = false;
    }
  }

  goBack() {
    const { pathname } = this.props;
    if (/rewards\/\d+$/.test(pathname)) {
      browserHistory.push("/");
    } else {
      browserHistory.goBack();
    }
  }

  goToHome() {
    browserHistory.push("/home/all");
  }

  goToLogin() {
    browserHistory.push("/login");
  }

  onCategorySelected(category) {
    browserHistory.push(`/home/${category}`);
  }

  // render

  render() {
    const { pathname } = this.props;
    const titleMessage = getPathMessage(pathname);
    const titleIsHome =
      /home/i.test(titleMessage.id) || /pathReward\b/i.test(titleMessage.id);
    const onTitleTouchTap = titleIsHome ? this.goToHome : undefined;

    return (
      <header>
        <AppBarStyled
          title={styles.titleStyle}
          onClick={onTitleTouchTap}
        >
          {this.renderButtonLeft()}
          {this.renderElementRight()}
        </AppBarStyled>
      </header>
    );
  }

  renderButtonLeft() {
    const { pathname, showLeftMenu } = this.props;
    const iconLeft = {};
    if (showBackButton(pathname)) {
      iconLeft.name = "arrow_back";
      iconLeft.action = this.goBack;
    } else {
      iconLeft.name = "Menu";
      iconLeft.action = showLeftMenu;
    }
    return (
      <div className="left-side">
        <IconButton onClick={iconLeft.action}>
          {iconLeft.name === "Menu" ? <Menu /> : <ArrowBack />}
        </IconButton>
      </div>
    );
  }

  renderElementRight() {
    // const { locale } = this.props;
    return <div></div>;
    /* return (<RSSelectField
      customStyles={{ width: '92px', margin: 0, padding: 0, display: 'inline-block', verticalAlign: 'middle' }}
      items={languages}
      bordered={false}
      itemSelected={locale}
      onChange={this.props.onChangeLanguage}
    />);*/
  }

  renderPointsPerCategory(category) {
    const primaryText = this.renderPointsPerCategoryText(category);
    return (
      <MenuItem
        style={{ color: "grey" }}
        key={category.id}
        onClick={() => this.onCategorySelected(category.id)}
      >
        {primaryText}
      </MenuItem>
    );
  }

  renderPointsPerCategoryText(category) {
    const { user, categoryId } = this.props;
    const points = get(
      find(user.points, { rewardCategoryId: category.id }),
      "points"
    );
    const selected = category.id === categoryId;
    return (
      <div>
        <span style={selected ? styles.menuItemNameSelected : {}}>
          {category.name}:{" "}
        </span>
        <span style={selected ? styles.menuItemValueSelected : {}}>
          <PointsLabel points={points} />
        </span>
      </div>
    );
  }

  renderButtonLogin() {
    return (
      <RoundedButton
        color="#000"
        style={{ fontSize: 14 }}
        label={this.renderMessage(messages.actionLogin)}
        onClick={this.goToLogin}
        className="header-loginbtn"
      />
    );
  }

  renderMessage(message) {
    return <FormattedMessage {...message}></FormattedMessage>;
  }
}

HeaderMobile.propTypes = {
  user: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  categoryId: PropTypes.number,
  pathname: PropTypes.string,
  // locale: PropTypes.string,
  showLeftMenu: PropTypes.func.isRequired,
  // onChangeLanguage: PropTypes.func.isRequired,
};

export default HeaderMobile;
